import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { Text, TextType } from 'ui-components/components/text';

import style from './shipment-details.module.less';

export const ShipmentDetailsField = ({ label, labelFor, labelIcon, children = null, className = '' }) => {
  return (
    <div className={classnames(style['shipment-value-container'], className)}>
      <div className={classnames(style['shipment-details-label-row'])}>
        <Text className={style['shipment-details-label']} htmlFor={labelFor} textType={TextType.Label} value={label} />
        {labelIcon}
      </div>
      <div className={style['shipment-value']}>{children}</div>
    </div>
  );
};

ShipmentDetailsField.propTypes = {
  label: PropTypes.node.isRequired,
  labelIcon: PropTypes.node,
  labelFor: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
};
